import { TransformRuleType } from "../../types/transformation/TransformationRuleTypes";

export {
  TransformRule,
  TransformRuleData,
  /** Transform rule variables */
  COUNTER_VAR,
  UUID_VAR,
  SOURCEFILENAME_VAR,
  OCRFILENAME_VAR,
  /** All transform rule variables */
  ALL_VARIABLES,
};

const COUNTER_VAR = "%%COUNTER";
const UUID_VAR = "%%UUID";
const SOURCEFILENAME_VAR = "%%SOURCEFILENAME";
const OCRFILENAME_VAR = "%%OCRFILENAME";

type TransformRuleData = {
  discriminator: TransformRuleType;
  fieldName: string;
  position: number;
};

const ALL_VARIABLES = [
  COUNTER_VAR,
  UUID_VAR,
  SOURCEFILENAME_VAR,
  OCRFILENAME_VAR,
];
const READONLY_VARIABLES: string[] = [COUNTER_VAR, UUID_VAR];

abstract class TransformRule {
  /**
   * Get all %%\w+ until end of the word
   */
  static VARIABLE_PREFIX = "%%";
  /**
   * Get all %%\w+
   */
  static VARIABLE_REGEX = /%%[A-Za-z]+/g;

  /**
   * Prefix of DLF variables
   */
  static DLF_VARIABLE_PREFIX = "$$";
  /**
   * Suffix of DLF variables
   */
  static DLF_VARIABLE_SUFFIX = "##";
  /**
   * Get all $$\w+ followed by 2 #
   */
  static DLF_VARIABLE_REGEX = /\$\$[A-Za-z\s\d]+(?=##)/g;

  discriminator: TransformRuleType;
  fieldName: string;
  position: number;
  constructor(data: TransformRuleData) {
    this.discriminator = data.discriminator;
    this.fieldName = data.fieldName;
    this.position = data.position;
  }

  /**
   *
   * @returns A distinct list of Dlf Variables for this rule.
   */
  abstract getDlfVariables(): string[];
  /**
   *
   * @returns A distinct list of Dlf Variables for this rule
   */
  // TODO: how should this be ordered ?
  protected _getDlfVariables(value: string): string[] {
    // get DlfVariables in fieldPattern
    const re = new RegExp(TransformRule.DLF_VARIABLE_REGEX);
    const variables = new Set<string>();
    let r;
    while ((r = re.exec(value))) {
      variables.add(r[0] + TransformRule.DLF_VARIABLE_SUFFIX);
    }

    return Array.from(variables.values());
  }

  /**
   *
   * @returns A distinct list of Variables for this rule.
   */
  abstract getVariables(): string[];
  /**
   *
   * @returns A distinct list of Variables for this rule.
   */
  // TODO: how should this be ordered ?
  protected _getVariables(value: string): string[] {
    // get varable in fieldPattern
    const re = new RegExp(TransformRule.VARIABLE_REGEX);
    const uniqVariables = new Set<string>();
    let r;
    while ((r = re.exec(value))) {
      uniqVariables.add(r[0]);
    }
    const variables = Array.from(uniqVariables.values());

    return ALL_VARIABLES.filter((x) => variables.includes(x));
  }

  getDiscriminator() {
    return this.discriminator;
  }

  abstract isConfigured(): boolean;

  /**
   * Gets the Rule Id that is unique enough to identify within the context of a single DocTypeConfig.
   */
  abstract getRuleId(): string;

  abstract toData(): TransformRuleData;
}
